import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/catch';
import {Injectable} from '@angular/core';
import {ApiEndpoints} from '../ApiEndpoints';
import {ApiUtils} from '../ApiUtils';
import 'rxjs/add/operator/map';
import { plainToClass } from 'class-transformer';
import { SharedMethods } from '../../../../util/sharedMethods-service';
import { Taxe } from '../../model/taxe';



@Injectable()
export class TaxeService {

  taxes: Taxe[] = [];

  iSconnecting: boolean = false;

  constructor(public apiEndpoints: ApiEndpoints, public http: HttpClient,
              public apiUtils: ApiUtils,
              // public networkService:NetworkService,
              // public sharedMethods: SharedMethods
              public sharedMethods: SharedMethods,
              ) { }

  getTaxes() {
    this.iSconnecting = true;
    return new Promise<Taxe[]>(resolve => {
      this.http.get(this.apiEndpoints.URL_GET_TAXE,
        {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
        .subscribe((data: Taxe[]) => {
            const taxes = plainToClass(Taxe, data);
            this.taxes = taxes;
            resolve(taxes);
            this.iSconnecting = false;
          },
          err => {
            // console.log(err);
            this.iSconnecting = false;
            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
          });
    });
  }

  saveTaxe(taxe: Taxe) {
    this.iSconnecting = true;


    const pat = {

      designation : taxe.designation,
      valeur: taxe.valeur,
      isAboutHT: taxe.is_about_h_t,
      typeCalcul: taxe.type_calcul,
      // parent: cat.parent,

    };


    if (taxe.id !== 0) {

      this.iSconnecting = true;

      return new Promise<Taxe>(resolve => {
        this.http.put(this.apiEndpoints.GET_URL_PUT_TAXE(taxe.id), pat,
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe((data: Taxe) => {

              this.getTaxes();
              resolve(data);
              this.iSconnecting = false;

            },
            err => {
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              // alert(JSON.stringify(err));
              this.iSconnecting = false;
            });
      });

    }else {

      return new Promise<Taxe>(resolve => {
        this.http.post(this.apiEndpoints.GET_URL_POST_TAXE, pat,
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe((data: Taxe) => {

              this.getTaxes();
              resolve(data);
              this.iSconnecting = false;

            },
            err => {
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              // alert(JSON.stringify(err));
              this.iSconnecting = false;
            });
      });

    }



  }

  deleteTaxe(taxe: Taxe) {
    this.iSconnecting = true;
    return new Promise(resolve => {
      this.http.delete(this.apiEndpoints.GET_URL_DELETE_TAXE(taxe.id),
        {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
        .subscribe(data => {

            this.getTaxes();
            resolve(data);
            this.iSconnecting = false;

          },
          err => {
            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
            // alert(JSON.stringify(err));
            this.iSconnecting = false;
          });
    });


  }


}
